import {
  pageSettingsLsgPalava,
  websiteSchemaLsgPalava,
  landingLsgPalava,
  homeAwardsLsgPalava,
} from "./LsgPalavaIndividualSiteData";

const PREMIER_PATH = "https://www.lodhaworldschool.com/premierpalava";

export const pageSettingsPremierPalava = {
  ...pageSettingsLsgPalava,
  landingPage: {
    ...pageSettingsLsgPalava.landingPage,
    title:
      "Lodha World School, Premier Palava - New Proposed CISCE School in Palava",
    metaTags: [
      {
        name: "description",
        content:
          "Applications for Lodha World School, Premier Palava are now open. New Proposed CISCE school in Palava, Dombivli East.",
      },
      {
        property: "og:title",
        content:
          "Lodha World School, Premier Palava - New Proposed CISCE School in Palava",
      },
      { property: "og:site_name", content: "LodhaWorldSchoolPremierPalava" },
      { property: "og:url", content: PREMIER_PATH },
      {
        property: "og:description",
        content:
          "Applications for Lodha World School, Premier Palava are now open. New Proposed CISCE school in Palava, Dombivli East.",
      },
      { property: "og:type", content: "website" },
      {
        property: "og:image",
        content: "https://www.lodhaworldschool.com/assets/images/lws-premier-palava-logo.png",
      },
    ],
    canonical: PREMIER_PATH,
  },
};

export const websiteSchemaPremierPalava = {
  ...websiteSchemaLsgPalava,
  name: "Lodha World School, Premier Palava",
  url: PREMIER_PATH + "/",
};

export const landingPremierPalava = {
  ...landingLsgPalava,
  title1: "Lodha World School, Premier Palava",
  title2: "New Proposed CISCE school in Palava",
  announcement: "Applications for Lodha World School, Premier Palava are now open.",
  logo: "/assets/lws-premier-palava-logo.jpg", // Static logo replacing GIF
  showHamburger: false,      // Disables the hamburger menu
  showNextArrow: false,      // Disables arrow to the next page
  contact: {
    address: "Central Avenue Road, Village Hedutane, Dombivli East, Maharashtra – 421 204",
    phoneDisplay: "T: 0251 663 9582 and 0251 664 2533",
    phones: ["0251 663 9582", "0251 664 2533"],
  },
};



export const starAwardsPremierPalava = [
  {
    imageSource: "/assets/starawards.png",
    name: "Applications for Lodha World School, Premier Palava are now open.",
    id: "premierPalavaApplications",
  },
  {
    imageSource: "/assets/starawards.png",
    name: (
      <>
        Address: Central Avenue Road, Village Hedutane, Dombivli East, Maharashtra – 421 204
        <br />
        T: 0251 663 9582 and 0251 664 2533
      </>
    ),
    id: "premierPalavaContact",
  },
];

export const homeAwardsPremierPalava = {
  imageSource: "/assets/starawards.png",
  name: "Applications for Lodha World School, Premier Palava are now open. Address: Central Avenue Road, Village Hedutane, Dombivli East, Maharashtra – 421 204 | T: 0251 663 9582 and 0251 664 2533",
  id: "premierPalavaContact",
};